import { useCallback } from "react";

import { usePromise } from "@touchtech/web-hooks";

import { BasketItemRequest } from "@is/hooks/basket";
import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createSignUpUrl } from "@is/services";

type ExtendedError = Error & { body: { error: string } };

type Params = {
  properties: { id: string; value: string }[];
  agreements: {
    isRequired: boolean;
    isChecked: boolean;
  }[];
};

type SignUpState = {
  isPending: boolean;
  error: ExtendedError | null;
  data: any;
};

async function handleSignUp(params: Params): Promise<any> {
  const url = createSignUpUrl();

  const data = await api.put(url, params);

  return data;
}

export const useSignUp = (): [
  SignUpState,
  (params: Params) => Promise<any>
] => {
  const [{ isPending, error, data }, dispatch] =
    usePromise<BasketItemRequest[]>();

  const { setApiHeaders } = useManageApiHeaders();

  setApiHeaders();

  const signUp = useCallback(
    (params: Params) => dispatch(handleSignUp(params)),
    [dispatch]
  );

  return [{ isPending, error: error as ExtendedError, data }, signUp];
};
